import { Identifiable, Project } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function updateProjectAllocatedBudget(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Project>, allocatedBudget: number) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/projects/${uuid}`,
      method: HttpMethods.PATCH,
      data: { allocatedBudget },
    });
}

export { updateProjectAllocatedBudget };
